import {
  drawBolt,
  flashesToDrawItems,
} from "./lightningDraw.js";

export function createLightningCanvasLayer(L) {
  return L.Layer.extend({
    initialize: function () {
      this._flashes = [];
      this._frameMs = null;
      this._hideFuture = false;
      this._items = [];
      this._raf = null;
      this._canvas = document.createElement("canvas");
      this._canvas.className = "leaflet-zoom-animated lightning-canvas";
      this._canvas.style.position = "absolute";
      this._canvas.style.pointerEvents = "none";
      this._canvas.style.zIndex = "455";
    },

    onAdd: function (map) {
      this._map = map;
      const paneName = "lightningPane";
      if (!map.getPane(paneName)) {
        const pane = map.createPane(paneName);
        pane.style.zIndex = "455";
      }
      map.getPane(paneName).appendChild(this._canvas);
      map.on("move zoom resize viewreset", this._scheduleRender, this);
      this._scheduleRender();
      return this;
    },

    onRemove: function (map) {
      if (this._raf) {
        cancelAnimationFrame(this._raf);
        this._raf = null;
      }
      map.off("move zoom resize viewreset", this._scheduleRender, this);
      if (this._canvas.parentNode) this._canvas.parentNode.removeChild(this._canvas);
      this._map = null;
      return this;
    },

    setFlashes: function (flashes, options = {}) {
      this._flashes = flashes || [];
      this._frameMs = options.frameMs;
      this._hideFuture = !!options.hideFuture;
      this._scheduleRender();
      return this;
    },

    clearFlashes: function () {
      this._flashes = [];
      this._items = [];
      this._scheduleRender();
      return this;
    },

    flashCount: function () {
      return this._items.length;
    },

    _scheduleRender: function () {
      if (!this._map) return;
      const topLeft = this._map.containerPointToLayerPoint([0, 0]);
      L.DomUtil.setPosition(this._canvas, topLeft);

      const mapSize = this._map.getSize();
      const dpr = window.devicePixelRatio || 1;
      const w = Math.max(1, Math.round(mapSize.x * dpr));
      const h = Math.max(1, Math.round(mapSize.y * dpr));
      if (this._canvas.width !== w || this._canvas.height !== h) {
        this._canvas.width = w;
        this._canvas.height = h;
        this._canvas.style.width = `${mapSize.x}px`;
        this._canvas.style.height = `${mapSize.y}px`;
      }

      if (this._raf) return;
      this._raf = requestAnimationFrame(() => {
        this._raf = null;
        this._render();
      });
    },

    _render: function () {
      if (!this._map) return;
      const dpr = window.devicePixelRatio || 1;
      const ctx = this._canvas.getContext("2d");
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);

      const drawItems = flashesToDrawItems(this._flashes, this._frameMs, this._hideFuture);
      const items = [];
      for (const item of drawItems) {
        const pt = this._map.latLngToContainerPoint([item.flash.lat, item.flash.lon]);
        drawBolt(ctx, pt.x, pt.y, item.sizePx, item.opacity);
        items.push({ ...item, x: pt.x, y: pt.y });
      }
      this._items = items;
    },
  });
}
